import { Cantons } from '../../../types/enums'

interface IProps {
  /** Size of loader in pixels. */
  licenceNumber?: string
  countryCode?: string
  width?: string
  height?: string
  formView?: boolean
}

const allCantons = Object.keys(Cantons)

const LicencePlateFlag = (props: IProps) => {
  const canton = props.licenceNumber?.substr(0, 2)?.toUpperCase()
  const plateNumber = props.licenceNumber?.substr(2, props.licenceNumber.length)?.toUpperCase()
  const isEU = props.countryCode !== 'CH' ? true : false
  return (
    <div className={!!props.countryCode && isEU ? 'eu plateArea' : 'plateArea'}>
      {/* {!props.formView ? (
        <>
          {!!props.countryCode && !isEU && (
            <img src={`../../../../kantons/CH.svg`} width={props.width} height={props.height} />
          )}

          <span>{props.licenceNumber}</span>
        </>
      ) : ( */}
      {!!props.countryCode && !isEU && (
        <img src={`../../../../kantons/CH.svg`} width={props.width} height={props.height} />
      )}
      <span>
        {canton}
        {props.formView && <span className="no-print">&#183;</span>}
        {plateNumber}
      </span>
      {/* )} */}

      {!!canton && allCantons.includes(canton) && (
        <img
          className="kanton"
          src={`../../../../kantons/${!!props.countryCode && isEU ? 'EU' : canton}.svg`}
          width={props.width}
          height={props.height}
        />
      )}
    </div>
  )
}

export default LicencePlateFlag
